export default __webpack_public_path__ + "images/referenzen/socialmedia/edeka_genussmomente_trailer2021.mp4";